import { authInstance } from './axios/index';
import qs from 'qs';

const hotelService = {
  // 호텔 상세 조회 - 아이디로 조회
  getHotel: (hotelId) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/hotel/${hotelId}`,
    };
    return authInstance(requestOptions);
  },
  //호텔 상세 조회
  getHotelById: (id) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/hotel/${id}/base`,
    };
    return authInstance(requestOptions);
  },
  //호텔 기본정보 수정
  putHotelById: (id, data) => {
    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      url: `/api/manage/v1/hotel/${id}/base`,
      data: JSON.stringify(data),
    };
    return authInstance(requestOptions);
  },
  //호텔 판매 정보
  getHotelSalesInfo: (id) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/hotel/${id}/sales`,
    };
    return authInstance(requestOptions);
  },
  //호텔 판매 정보 수정
  putHotelSalesInfo: (id, data) => {
    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      url: `/api/manage/v1/hotel/${id}/sales`,
      data: JSON.stringify(data),
    };
    return authInstance(requestOptions);
  },
  //호텔 객실 정보 목록 조회
  getHotelRoomsById: (id) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/hotel/${id}/room`,
    };
    return authInstance(requestOptions);
  },
  //호텔 객실 정보 등록
  postHotelRoom: (id, data) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/manage/v1/hotel/${id}/room`,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      data: JSON.stringify(data),
    };
    return authInstance(requestOptions);
  },
  //호텔 객실 정보 수정
  putHotelRoom: (id, data) => {
    const requestOptions = {
      method: 'PUT',
      url: `/api/manage/v1/hotel/room/${id}`,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      data: JSON.stringify(data),
    };
    return authInstance(requestOptions);
  },
  //호텔 객실 숨김 처리
  hiddenHotelRoom: (id) => {
    const requestOptions = {
      method: 'PATCH',
      url: `/api/manage/v1/hotel/room/${id}/hidden`,
    };
    return authInstance(requestOptions);
  },
  //호텔 객실 보기 처리
  viewHotelRoom: (id) => {
    const requestOptions = {
      method: 'PATCH',
      url: `/api/manage/v1/hotel/room/${id}/view`,
    };
    return authInstance(requestOptions);
  },
  //호텔 룸 순서 변경
  patchHotelRoomOrder: (hotelId, roomId, order) => {
    // /api/manage/v1/hotel/{hotel-id}/room/{room-id}/order/{order}
    const requestOptions = {
      method: 'PATCH',
      url: `/api/manage/v1/hotel/${hotelId}/room/${roomId}/order/${order}`,
    };
    return authInstance(requestOptions);
  },
  //호텔 객실 삭제
  deleteHotelRoom: (hotelId, roomId) => {
    const requestOptions = {
      method: 'DELETE',
      url: `/api/manage/v1/hotel/${hotelId}room/${roomId}`,
    };
    return authInstance(requestOptions);
  },
  //호텔 요금 관리 조회
  getHotelChargeById: (hotelId) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/hotel/${hotelId}/charge`,
    };
    return authInstance(requestOptions);
  },
  //호텔 요금 수정
  putHotelCharge: (hotelId, data) => {
    const requestOptions = {
      method: 'PUT',
      url: `/api/manage/v1/hotel/${hotelId}/charge`,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      data: JSON.stringify(data),
    };
    return authInstance(requestOptions);
  },
  //호텔 요금정보 삭제
  deleteHotelCharge: (hotelId, chargeId) => {
    const requestOptions = {
      method: 'DELETE',
      url: `/api/manage/v1/hotel/${hotelId}/charge/${chargeId}`,
    };
    return authInstance(requestOptions);
  },
  //호텔 캔슬차지 수정
  putHotelCancelCharge: (hotelId, params, method = 'POST') => {
    const requestOptions = {
      // 정책이 이미 존재하면 수정 API를 사용하고, 없는 호텔은 등록 API를 사용합니다.
      method,
      url: `/api/manage/v1/hotel/${hotelId}/cancel-charge?${qs.stringify(
        params,
        {
          arrayFormat: 'repeat',
        },
      )}`,
    };
    return authInstance(requestOptions);
  },
  //여행사 그룹조회
  getTravelRateGroup: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/hotel/travel/rate-group?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return authInstance(requestOptions);
  },
  //여행사 그룹 변경
  putTravelRateGroup: (rateGroupId, params) => {
    const requestOptions = {
      method: 'PUT',
      url: `/api/manage/v1/hotel/travel/rate-group/${rateGroupId}?${qs.stringify(
        params,
        {
          arrayFormat: 'repeat',
        },
      )}`,
    };
    return authInstance(requestOptions);
  },
  //여행사 그룹 단체 지정
  putTravelRateGroups: (data) => {
    const requestOptions = {
      method: 'PUT',
      url: `/api/manage/v1/hotel/travel/rate-groups`,
      data,
    };
    return authInstance(requestOptions);
  },
  //여행사 그룹 삭제
  deleteTravelRateGroup: (rateGroupId) => {
    const requestOptions = {
      method: 'DELETE',
      url: `/api/manage/v1/hotel/travel/rate-group/${rateGroupId}`,
    };
    return authInstance(requestOptions);
  },
  //여행사 그룹 삭제
  deleteTravelRateGroups: (params) => {
    const requestOptions = {
      method: 'DELETE',
      url: `/api/manage/v1/hotel/travel/rate-groups?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return authInstance(requestOptions);
  },
  //여행사 그룹 단체 미지정(복구)
  unspecifiedTravelRateGroup: (rateGroupId) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/manage/v1/hotel/travel/rate-group/${rateGroupId}/unspecified`,
    };
    return authInstance(requestOptions);
  },
  //호텔 직원 조회
  getHotelStaffList: (hotelId, params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/hotel/${hotelId}/staff?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return authInstance(requestOptions);
  },
  // 호텔의 객실 요금 그룹 타입 조회
  getHotelRateGroupTypes: (hotelId) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/hotel/${hotelId}/rate-group-types`,
    };
    return authInstance(requestOptions);
  },
  // 호텔-여행사 그룹별 금액 가져오기
  getHotelTravelrateGroupCharge: (hotelId, travelId, params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/hotel/${hotelId}/travel/${travelId}/rate-group/charge?${qs.stringify(
        params,
        {
          arrayFormat: 'repeat',
        },
      )}`,
    };
    return authInstance(requestOptions);
  },
  // 호텔 캔슬차지 조회
  getHotelCancelChargeById: (hotelId) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/hotel/${hotelId}/cancel-charge`,
    };
    return authInstance(requestOptions);
  },
  // 호텔 여행사 그룹 지정 - * 견적 상세에서 해당 여행사 그룹관리가 되어 있지 않을 시
  setHotelTravelRateGroupByInquiry: (hotelId, travelId, rateGroupCode) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/manage/v1/hotel/${hotelId}/travel/${travelId}/rate-group/${rateGroupCode}`,
    };
    return authInstance(requestOptions);
  },
  //회사 정보 관리 설정 여부
  getHotelSettingInfo: (hotelId) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/hotel/${hotelId}/setting-info`,
    };
    return authInstance(requestOptions);
  },
};

export default hotelService;
